module.exports = __webpack_public_path__ + "static/media/Avenir-Book-Italic.9e92ef8c.ttf";